<style scoped>
.search-block {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  display: flex;
  align-items: center;
  visibility: visible;
  opacity: 1;
  z-index: 1011;
  transition: 0.15s;
}
.search-block.hidden {
  top: -50vh;
  visibility: hidden;
  opacity: 0;
}
.search-block-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  visibility: visible;
  opacity: 1;
  z-index: 1010;
  transition: 0.15s;
}
.search-block-backdrop.hidden {
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
}
.dropdown .card {
  position: relative;
  overflow: hidden;
}
.dropdown .card img {
  width: 100%;
  height: auto;
  transition: filter none;
}
.dropdown .card:hover img {
  filter: brightness(75%);
}
.dropdown .card .card-title {
  margin-bottom: 0;
  padding: 0.75rem;
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  font-size: 12px;
  color: #fff;
  background: rgba(0, 0, 0, 1);
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
  line-height: 1;
}
@media (max-width: 992px) {
  .dropdown .card img {
    max-width: unset;
    width: 100%;
  }
  .btn-primary.btn-icon {
    width: 100% !important;
  }
}
@media (max-width: 768px) {
  .dropdown .dropdown-menu {
    left: 0;
    width: 100%;
  }
}
</style>

<template>
  <div>
    <div class="search-block-backdrop hidden" @click="toggleSearch()"></div>
    <div class="search-block d-flex flex-column hidden bg-white border-bottom py-0">
      <div class="container">
        <div class="d-flex justify-content-between w-100 py-3 py-md-4">
          <div class="d-flex flex-column">
            <h5 class="fw-bold mb-2">Search</h5>
            <p class="text-muted mb-0">Find and experience the best places.</p>
          </div>
          <a href="#" @click.prevent="toggleSearch()" class="fw-bold text-dark">Close</a>
        </div>
      </div>
      <div class="border-bottom w-100" style="height: 1px"></div>
      <div class="container">
        <div class="w-100 py-3 py-md-4">
          <div class="d-flex flex-column flex-lg-row gap-2 w-100">
            <div class="row g-2 w-100">
              <div class="col-lg-4">
                <div class="dropdown">
                  <button
                    class="btn btn-default text-start w-100 dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="true"
                    aria-expanded="false"
                  >
                    <div class="d-flex justify-content-between gap-4">
                      <div v-if="city == ''">
                        <i class="fas fa-home me-3"></i>Search destinations
                      </div>
                      <div v-else>{{ city }}</div>
                      <a href="#" v-if="city != ''" @click.prevent="city = ''">
                        <i class="fas fa-times text-danger"></i>
                      </a>
                    </div>
                  </button>
                  <div class="dropdown-menu p-4 w-100">
                    <div class="text-muted d-flex justify-content-between gap-4 mb-3">
                      Select city
                      <span v-if="city != ''">
                        <a
                          href="#"
                          role="button"
                          @click.prevent="city = ''"
                          class="fw-bold text-danger"
                        >
                          Clear</a
                        >
                      </span>
                    </div>
                    <div class="row g-2">
                      <div v-for="place in places" class="col-4">
                        <a href="#" class="card" @click.prevent="city = place.CityName">
                          <img src="@/assets/img/cities/quezon-city.webp" alt="..." />
                          <div class="card-title w-100 text-truncate">
                            {{ place.CityName }}
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <input
                  class="form-control date-range"
                  type="text"
                  name="datetimes"
                />
              </div>
              <div class="col-lg-4">
                <div class="dropdown">
                  <button
                    class="btn btn-default text-start w-100 dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                    aria-expanded="false"
                  >
                    <div class="d-flex justify-content-between gap-4">
                      <div v-if="total_count == 0">
                        <i class="fas fa-user me-3"></i>Add guests
                      </div>
                      <div v-else>
                        <span v-if="total_count <= 1">{{ total_count }} guest</span>
                        <span v-else>{{ total_count }} guests</span>
                      </div>
                      <a
                        href="#"
                        v-if="total_count != ''"
                        @click.prevent="
                          (adult_count = 0),
                            (child_count = 0),
                            (infant_count = 0),
                            (pet_count = 0),
                            (total_count = 0)
                        "
                      >
                        <i class="fas fa-times text-danger"></i>
                      </a>
                    </div>
                  </button>
                  <div class="dropdown-menu p-4 w-100">
                    <div class="text-muted d-flex justify-content-between gap-4 mb-3">
                      Select type
                      <span
                        v-if="
                          adult_count != 0 ||
                          child_count != 0 ||
                          infant_count != 0 ||
                          pet_count != 0
                        "
                      >
                        <a
                          href="#"
                          role="button"
                          @click.prevent="
                            (adult_count = 0),
                              (child_count = 0),
                              (infant_count = 0),
                              (pet_count = 0),
                              (total_count = 0)
                          "
                          class="fw-bold text-danger"
                        >
                          Clear</a
                        >
                      </span>
                    </div>
                    <div class="d-flex flex-column gap-3">
                      <div
                        class="d-flex justify-content-between align-items-center gap-3 gap-lg-5"
                      >
                        <div class="d-flex flex-column">
                          <span class="fw-bold">Adults</span>
                          <span class="small text-muted">Ages 13 or Above</span>
                        </div>
                        <div class="d-inline-block">
                          <div class="input-group">
                            <button
                              class="btn btn-default btn-icon btn-icon-xs"
                              :disabled="adult_count <= 0"
                              @click="
                                subtractAdultCount(1);
                                addTotalCount();
                              "
                            >
                              <i class="fas fa-minus fa-sm"></i>
                            </button>
                            <input
                              type="text"
                              v-model="adult_count"
                              class="form-control form-control-sm bg-white text-center"
                              style="width: 40px"
                              readonly
                            />
                            <button
                              class="btn btn-default btn-icon btn-icon-xs"
                              @click="
                                addAdultCount(1);
                                addTotalCount();
                              "
                            >
                              <i class="fas fa-plus fa-sm"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        class="d-flex justify-content-between align-items-center gap-3 gap-lg-5"
                      >
                        <div class="d-flex flex-column">
                          <span class="fw-bold">Children</span>
                          <span class="small text-muted">Ages 2-12</span>
                        </div>
                        <div class="d-inline-block">
                          <div class="input-group">
                            <button
                              class="btn btn-default btn-icon btn-icon-xs"
                              :disabled="child_count <= 0"
                              @click="
                                subtractChildCount(1);
                                addTotalCount();
                              "
                            >
                              <i class="fas fa-minus fa-sm"></i>
                            </button>
                            <input
                              type="text"
                              value="0"
                              class="form-control form-control-sm bg-white text-center"
                              style="width: 40px"
                              readonly
                              v-model="child_count"
                            />
                            <button
                              class="btn btn-default btn-icon btn-icon-xs"
                              @click="
                                addChildCount(1);
                                addTotalCount();
                              "
                            >
                              <i class="fas fa-plus fa-sm"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        class="d-flex justify-content-between align-items-center gap-3 gap-lg-5"
                      >
                        <div class="d-flex flex-column">
                          <span class="fw-bold">Infants</span>
                          <span class="small text-muted">Under 2</span>
                        </div>
                        <div class="d-inline-block">
                          <div class="input-group">
                            <button
                              class="btn btn-default btn-icon btn-icon-xs"
                              :disabled="infant_count <= 0"
                              @click="
                                subtractInfantCount(1);
                                addTotalCount();
                              "
                            >
                              <i class="fas fa-minus fa-sm"></i>
                            </button>
                            <input
                              type="text"
                              value="0"
                              class="form-control form-control-sm bg-white text-center"
                              style="width: 40px"
                              readonly
                              v-model="infant_count"
                            />
                            <button
                              class="btn btn-default btn-icon btn-icon-xs"
                              @click="
                                addInfantCount(1);
                                addTotalCount();
                              "
                            >
                              <i class="fas fa-plus fa-sm"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        class="d-flex justify-content-between align-items-center gap-3 gap-lg-5"
                      >
                        <div class="d-flex flex-column">
                          <span class="fw-bold">Pets</span>
                          <a href="#" class="small text-muted"
                            >Bringing a service animal?</a
                          >
                        </div>
                        <div class="d-inline-block">
                          <div class="input-group">
                            <button
                              class="btn btn-default btn-icon btn-icon-xs"
                              :disabled="pet_count <= 0"
                              @click="
                                subtractPetCount(1);
                                addTotalCount();
                              "
                            >
                              <i class="fas fa-minus fa-sm"></i>
                            </button>
                            <input
                              type="text"
                              value="0"
                              class="form-control form-control-sm bg-white text-center"
                              style="width: 40px"
                              readonly
                              v-model="pet_count"
                            />
                            <button
                              class="btn btn-default btn-icon btn-icon-xs"
                              @click="
                                addPetCount(1);
                                addTotalCount();
                              "
                            >
                              <i class="fas fa-plus fa-sm"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-block">
              <button class="btn btn-default btn-icon">
                <span class="d-inline d-lg-none me-3">Search</span>
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SearchBlock",
  data: () => ({
    adult_count: 0,
    child_count: 0,
    infant_count: 0,
    pet_count: 0,
    total_count: 0,
    city: "",
    places: [],
  }),
  mounted() {
    this.getPlaces();
  },
  methods: {
    toggleSearch() {
      $(".search-block").toggleClass("hidden");
      $(".search-block-backdrop").toggleClass("hidden");
      $("#body").toggleClass("overflow-hidden");
    },
    addTotalCount() {
      this.total_count =
        this.adult_count + this.child_count + this.infant_count + this.pet_count;
    },
    addAdultCount: function (inc) {
      this.adult_count += inc;
    },
    subtractAdultCount: function (dec) {
      if (this.adult_count > 0) {
        this.adult_count -= dec;
      }
    },
    addChildCount: function (inc) {
      this.child_count += inc;
    },
    subtractChildCount: function (dec) {
      if (this.child_count > 0) {
        this.child_count -= dec;
      }
    },
    addInfantCount: function (inc) {
      this.infant_count += inc;
    },
    subtractInfantCount: function (dec) {
      if (this.infant_count > 0) {
        this.infant_count -= dec;
      }
    },
    addPetCount: function (inc) {
      this.pet_count += inc;
    },
    subtractPetCount: function (dec) {
      if (this.pet_count > 0) {
        this.pet_count -= dec;
      }
    },
    async getPlaces() {
      const res = await axios.get("https://testbnb-api.nsjbi.com.ph/api/places");
      this.places = JSON.parse(res.data);
    },
  },
};
</script>
